"use client";

/**
 * Menú 2.2 — panel lateral a página completa: isotipo, entradas grandes y
 * columna de perfil a la derecha.
 */

import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";

import { useApp } from "@/components/app/proveedor";
import { IconoAtras } from "@/components/app/iconos";

const ENTRADAS = [
  { label: "Mi perfil", href: "/cuenta" },
  { label: "Mis pedidos", href: "/pedidos" },
  { label: "Cobertura y horarios", href: "/cobertura" },
  { label: "Cómo funciona", href: "/como-funciona" },
  { label: "Ayuda", href: "/ayuda" },
  { label: "Nuestra historia", href: "/historia" },
  { label: "Sé distribuidor", href: "/distribuidores" },
  { label: "Contacto", href: "/contacto" },
];

export default function PaginaMenu() {
  const router = useRouter();
  const { usuario } = useApp();
  const inicial = (usuario?.nombre || "F").charAt(0).toUpperCase();

  return (
    <div className="anim-bz-in relative flex min-h-(--alto-app) bg-[#f9f9f9]">
      <div className="relative flex-1 overflow-auto bg-white pb-10">
        <button
          type="button"
          aria-label="Cerrar menú"
          onClick={() => router.back()}
          className="absolute top-[38px] left-[30px] flex h-[34px] w-[34px] items-center justify-center"
        >
          <IconoAtras size={24} color="#000" strokeWidth={2.6} />
        </button>
        <Image
          src="/brand/isotipo-verde.png"
          alt=""
          width={102}
          height={102}
          className="mt-[104px] ml-[5px] h-[88px] w-[88px] object-contain"
        />
        <nav className="mt-7 ml-[34px] flex flex-col gap-[24px] pr-4 pb-10">
          {ENTRADAS.map((e) => (
            <Link
              key={e.href}
              href={e.href}
              className="max-w-[252px] font-sans text-3xl leading-[35px] font-black text-black transition-colors hover:text-verde"
            >
              {e.label}
            </Link>
          ))}
        </nav>
      </div>
      <Link
        href={usuario ? "/cuenta" : "/acceso?next=/cuenta"}
        aria-label="Mi cuenta"
        className="flex w-[67px] flex-none justify-center bg-[linear-gradient(180deg,#1E8A40,#082411)] pt-11"
      >
        <span className="flex h-[38px] w-[38px] items-center justify-center rounded-full bg-lima font-app text-[15px] font-black text-bosque">
          {inicial}
        </span>
      </Link>
    </div>
  );
}
